import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

const API_BASE = process.env.REACT_APP_API_BASE || "https://beintelli.engaggio.com/handlers";

export default function AdminDashboard() {
  const { logout } = useAuth();
  const [stats, setStats] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    Promise.all([
      fetch(`${API_BASE}/admin/dashboard`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()),
      fetch(`${API_BASE}/admin/users`,     { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()),
    ]).then(([dash, usersData]) => {
      setStats(dash.stats || dash);
      setUsers(usersData.users || []);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={s.center}>Loading...</div>;

  return (
    <div style={s.page}>
      <div style={s.header}>
        <div>
          <h1 style={s.title}>Admin Dashboard</h1>
          <p style={s.sub}>Engaggio Platform Management</p>
        </div>
        <button style={s.logout} onClick={logout}>Sign Out</button>
      </div>

      {/* Stats */}
      {stats && (
        <div style={s.grid}>
          {Object.entries(stats).map(([key, val]) => (
            <div key={key} style={s.card}>
              <p style={s.cardLabel}>{key.replace(/_/g, " ").toUpperCase()}</p>
              <p style={s.cardVal}>{val ?? "—"}</p>
            </div>
          ))}
        </div>
      )}

      {/* Users table */}
      <div style={s.tableWrap}>
        <h2 style={s.tableTitle}>All Users</h2>
        <table style={s.table}>
          <thead>
            <tr>
              {["ID", "Name", "Email", "Role", "Status"].map(h => (
                <th key={h} style={s.th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id} style={s.tr}>
                <td style={s.td}>{u.id}</td>
                <td style={s.td}>{u.username || "—"}</td>
                <td style={s.td}>{u.email || "—"}</td>
                <td style={s.td}><span style={{ ...s.badge, background: roleColor(u.role) }}>{u.role}</span></td>
                <td style={s.td}><span style={{ color: u.status === "active" ? "#16a34a" : "#dc2626", fontWeight: 600 }}>{u.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function roleColor(role) {
  return { admin: "#1e293b", parent: "#6366f1", learner: "#0891b2", educator: "#059669", institution: "#d97706" }[role] || "#6b7280";
}

const s = {
  page:       { maxWidth: 1100, margin: "0 auto", padding: "32px 24px", fontFamily: "'Inter','Segoe UI',sans-serif" },
  header:     { display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 32 },
  title:      { fontSize: 24, fontWeight: 700, color: "#0f172a", margin: 0 },
  sub:        { fontSize: 14, color: "#64748b", margin: "4px 0 0" },
  logout:     { padding: "8px 20px", background: "#fff", border: "1.5px solid #fca5a5", color: "#dc2626", borderRadius: 8, fontWeight: 600, cursor: "pointer", fontSize: 14 },
  grid:       { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 16, marginBottom: 32 },
  card:       { background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: "20px 16px", textAlign: "center" },
  cardLabel:  { fontSize: 11, color: "#94a3b8", fontWeight: 700, letterSpacing: "0.6px", margin: "0 0 8px" },
  cardVal:    { fontSize: 28, fontWeight: 700, color: "#1e293b", margin: 0 },
  tableWrap:  { background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, overflow: "hidden" },
  tableTitle: { fontSize: 15, fontWeight: 700, color: "#1e293b", padding: "16px 20px", margin: 0, borderBottom: "1px solid #f1f5f9" },
  table:      { width: "100%", borderCollapse: "collapse" },
  th:         { padding: "12px 16px", textAlign: "left", fontSize: 12, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "1px solid #f1f5f9" },
  tr:         { borderBottom: "1px solid #f8fafc" },
  td:         { padding: "12px 16px", fontSize: 14, color: "#374151" },
  badge:      { display: "inline-block", padding: "2px 10px", borderRadius: 999, color: "#fff", fontSize: 11, fontWeight: 600 },
  center:     { display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontSize: 16, color: "#64748b" },
};
